<template>
  <v-layout
    row
    wrap
    @click="goToOrders(detail)"
  >
    <v-flex
      xs8
      text-xs-left
    >
      <div class="">
        Contract Title:
        <b>{{ detail.contract.title }}</b>
      </div>
      <div class="">
        Invest Type:
        <b>{{ detail.investtype }}</b>
      </div>
      <div class="">
        Product Type:
        <b>{{ detail.contract.product_type }}</b>
      </div>
      <div class="">
        Bound Type:
        <b>{{ detail.contract.bond_type }}</b>
      </div>
    </v-flex>
    <v-flex
      xs4
      text-xs-center
    >
      <v-chip
        label
        color="blue darken-3"
        text-color="white"
      >
        <v-icon left>
          monetization_on
        </v-icon>Amount:
        <span>
          <b>{{ detail.pieces * detail.contract.piece_value | currency('€') }}</b>
        </span>
      </v-chip>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'UserSignDetail',
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    goToOrders(detail) {
      this.$router.push({ name: 'orders', query: { query: detail.user_id, accountId: detail.contract.account } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/users/backend/UserSignDetail.vue